module.exports = __webpack_public_path__ + "sondage.png?12dd7afe9e2a660fa6e8638aa54629c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sondage.png
// module id = 199
// module chunks = 0